import { api } from './api';

export const getParents = (params?: { search?: string; cursor?: string; limit?: number }) =>
  api.get('/admin/users', { params: { ...params, role: 'PARENT' } });
